import i18n from 'i18next'
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

const getInitialLanguage = () => {
    try {
        const savedLanguage = localStorage.getItem('selectedLanguage');
        return savedLanguage || "en-us";
    } catch (error) {
        return "en-us";
    }
};

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({

        lng: getInitialLanguage(),

        fallbackLng: "en-us",

        debug: false,

        backend: {
            loadPath: "/assets/locales/{{lng}}.json",
        },

        ns: ["translations"],

        defaultNS: "translations",

        keySeparator: false,

        interpolation: {

            escapeValue: false,

            formatSeparator: ",",

        },

        react: {

            wait: true,

        },

    });


export default i18n;